import { Injectable } from '@angular/core';
import { AuthenticationService } from "./authentication/authentication.service";
import { LoggingService } from "./logging/logging.service";
import { LazyLoadEvent } from "../models/DataTables/lazyLoadEvent";
import { EditEventModel, CreateEventModel, IEvent } from "../models/inModels/Event";
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EventsService {
	private routeCategory = '/api/events';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<IEvent> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as IEvent)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateEventModel): Promise<IEvent> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create/admin`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as IEvent)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditEventModel): Promise<IEvent> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as IEvent)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownList(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/events/dropdown`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/events.service.ts